import { clone } from "lodash";
import { AddressConstant } from "@/common/constant/AddressConstant";

export const isInternationalAddress = (DTO: { countryCode?: string } | undefined | null): boolean =>
  Boolean(DTO?.countryCode) && DTO?.countryCode !== AddressConstant.DEFAULT_COUNTRY_CODE;

export const hasForeignAddressFields = (DTO: { region?: string; postalCode?: string } | undefined | null): boolean =>
  Boolean(DTO?.region?.trim() || DTO?.postalCode?.trim());

export const isSameZipCode = (zipCode1?: string | null, zipCode2?: string | null): boolean =>
  (zipCode1 ?? "").replace(/\D/g, "") === (zipCode2 ?? "").replace(/\D/g, "");

class AddressUtil {
  splitZip(DTO: any) {
    //Using clone because one variable
    const message: any = clone(DTO);
    if (hasForeignAddressFields(message)) {
      delete message.zipCode;
      delete message.zipCodeSuffix;
      delete message.state;
      return message;
    }
    if (!message.zipCode) {
      delete message.zipCodeSuffix;
      return message;
    }
    if (message.zipCode.length > 5) {
      message.zipCode = message.zipCode.replace("-", "");
      message.zipCodeSuffix = message.zipCode.substr(5, message.zipCode.length);
      message.zipCode = message.zipCode.substr(0, 5);
    } else {
      delete message.zipCodeSuffix;
    }

    return message;
  }

  getMergedZipCode(zipCode: any, zipCodeSuffix: any) {
    return (zipCode || "") + (zipCodeSuffix || "");
  }
}

export default AddressUtil
